'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var React = require('react');
var Helmet = require('react-helmet').default;
var objectEntries = require('object.entries');
var objectAssign = require('object-assign');

var HelmetDatoCms = function HelmetDatoCms(_ref) {
  var seo = _ref.seo,
      favicon = _ref.favicon,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ['seo', 'favicon', 'children']);

  return React.createElement(Helmet, rest, (seo ? seo.tags : []).concat(favicon ? favicon.tags : []).map(function (item, i) {
    return React.createElement(item.tagName, objectAssign({ key: 'helmet-datocms-' + i }, objectEntries(item.attributes || {}).reduce(function (acc, _ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          name = _ref3[0],
          value = _ref3[1];

      if (value) {
        acc[name] = value;
      }
      return acc;
    }, {})), item.content);
  }).concat(children));
};

module.exports = { HelmetDatoCms: HelmetDatoCms };


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-source-datocms/index.js
// module id = 520
// module chunks = 35783957827783